import React from 'react';

function Nav () {
  return <div className='nav'></div>
}

export default Nav;